import React from "react";
import {
  Box,
  Flex,
  HStack,
  Image,
  Link,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FiMenu } from "react-icons/fi";

const navItems = [
  { label: "Work", href: "/work" },
  { label: "Institute", href: "/institute" },
  { label: "Community", href: "/community" },
  { label: "Partner", href: "/partner" },
  { label: "About", href: "/about" },
];

function SiteHeader() {
  return (
    <Box
      as="header"
      position="sticky"
      top="0"
      zIndex="1000"
      bg="rgba(255, 255, 255, 0.94)"
      backdropFilter="blur(12px)"
      borderBottom="1px solid"
      borderColor="blackAlpha.100"
    >
      <Flex
        maxW="1400px"
        mx="auto"
        px={{ base: 4, md: 8, lg: 12 }}
        h={{ base: "72px", md: "80px" }}
        align="center"
        justify="space-between"
      >
        {/* Brand */}
        <Link
          href="/"
          _hover={{ textDecoration: "none" }}
          aria-label="Serena Space home"
          display="flex"
          alignItems="center"
          flexShrink={1}
          minW={0}
        >
          <Box
            w={{ base: "155px", md: "195px" }}
            h={{ base: "40px", md: "48px" }}
            overflow="hidden"
            display="flex"
            alignItems="center"
            flexShrink={1}
            bg="transparent"
          >
            <Image
              src="/images/institutional/serena-space-logo-lockup.svg"
              alt="Serena Space"
              w={{ base: "155px", md: "195px" }}
              h="auto"
              display="block"
              bg="transparent"
            />
          </Box>
        </Link>

        {/* Desktop Navigation */}
        <HStack
          as="nav"
          spacing={{ md: 6, lg: 8 }}
          display={{ base: "none", md: "flex" }}
          aria-label="Main navigation"
          ml="auto"
          mr={{ md: 6, lg: 8 }}
        >
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              fontFamily="'Poppins', sans-serif"
              fontSize="sm"
              fontWeight="500"
              color="#34413D"
              position="relative"
              _hover={{
                color: "#087F73",
                textDecoration: "none",
              }}
            >
              {item.label}
            </Link>
          ))}
        </HStack>

        {/* Mobile Controls */}
        <HStack
          display={{ base: "flex", md: "none" }}
          spacing={2}
          flexShrink={0}
          ml={2}
        >
          {/* Mobile Selense CTA */}
          <Link
            href="https://selense.serenaspace.com"
            isExternal
            px={3.5}
            py={2.5}
            borderRadius="full"
            bg="#087F73"
            color="white"
            fontFamily="'Poppins', sans-serif"
            fontSize="xs"
            fontWeight="600"
            whiteSpace="nowrap"
            flexShrink={0}
            _hover={{
              bg: "#06695F",
              textDecoration: "none",
            }}
            transition="background-color 0.2s ease"
          >
            Try Selense
          </Link>

          {/* Mobile Navigation */}
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Open navigation menu"
              icon={<FiMenu size={22} />}
              variant="ghost"
              color="#17211F"
              fontSize="xl"
              flexShrink={0}
              _hover={{
                bg: "blackAlpha.50",
              }}
              _active={{
                bg: "blackAlpha.100",
              }}
            />

            <MenuList
              minW="220px"
              borderRadius="lg"
              py={2}
              boxShadow="lg"
            >
              {navItems.map((item) => (
                <MenuItem
                  key={item.href}
                  as="a"
                  href={item.href}
                  fontFamily="'Poppins', sans-serif"
                  fontSize="sm"
                  fontWeight="500"
                  color="#34413D"
                  _hover={{
                    bg: "blackAlpha.50",
                    color: "#087F73",
                  }}
                >
                  {item.label}
                </MenuItem>
              ))}

              <MenuItem
                as="a"
                href="https://selense.serenaspace.com"
                target="_blank"
                rel="noopener noreferrer"
                fontFamily="'Poppins', sans-serif"
                fontSize="sm"
                fontWeight="600"
                color="#087F73"
              >
                Try Selense
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>

        {/* Desktop Selense CTA */}
        <Link
          href="https://selense.serenaspace.com"
          isExternal
          display={{ base: "none", md: "inline-flex" }}
          px={5}
          py={2.5}
          borderRadius="full"
          bg="#087F73"
          color="white"
          fontFamily="'Poppins', sans-serif"
          fontSize="sm"
          fontWeight="600"
          whiteSpace="nowrap"
          flexShrink={0}
          _hover={{
            bg: "#06695F",
            textDecoration: "none",
          }}
          transition="background-color 0.2s ease"
        >
          Try Selense
        </Link>
      </Flex>
    </Box>
  );
}

export default SiteHeader;